var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcXlsx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 471.3 500",
    style: {
      enableBackground: "new 0 0 471.3 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#103DAF;}\n\t.st1{fill:#5895FF;}\n\t.st2{fill:#FFFFFF;fill-opacity:0.4;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#1E49D3;enable-background:new    ;}\n\t.st5{fill:#043017;}\n\t.st6{fill:#157241;}\n\t.st7{fill:#34935F;}\n\t.st8{fill:#07542A;}\n\t.st9{fill:#BC3228;}\n\t.st10{fill:#F45B42;}\n\t.st11{fill:#CC493B;}\n\t.st12{fill:#F98073;}\n\t.st13{fill:#073551;}\n\t.st14{fill:#48A8FF;}\n\t.st15{fill:#2477B5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "0,266.9 80.7,228.7 80.7,266.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "471.3,266.9 390.5,228.7 390.5,266.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M276.4,0.5l163,166v273.9c0,32.1-25.5,58.1-57,58.1H89c-31.5,0-57-26-57-58.1V58.6c0-32.1,25.5-58.1,57-58.1 H276.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M439.4,166.4H336.3c-31.5,0-59.9-28.9-59.9-61V0.5L439.4,166.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M169.7,218.3L169.7,218.3c0,5.7-4.6,10.4-10.4,10.4H98.6c-5.7,0-10.4-4.6-10.4-10.4v0 c0-5.7,4.6-10.4,10.4-10.4h60.7C165.1,207.9,169.7,212.6,169.7,218.3z M251.2,176.8L251.2,176.8c0,5.7-4.6,10.4-10.4,10.4H98.6 c-5.7,0-10.4-4.6-10.4-10.4v0c0-5.7,4.6-10.4,10.4-10.4h142.2C246.6,166.5,251.2,171.1,251.2,176.8z M251.2,135.3L251.2,135.3 c0,5.7-4.6,10.4-10.4,10.4H98.6c-5.7,0-10.4-4.6-10.4-10.4v0c0-5.7,4.6-10.4,10.4-10.4h142.2C246.6,125,251.2,129.6,251.2,135.3z  M251.2,93.8L251.2,93.8c0,5.7-4.6,10.4-10.4,10.4H98.6c-5.7,0-10.4-4.6-10.4-10.4v0c0-5.7,4.6-10.4,10.4-10.4h142.2 C246.6,83.4,251.2,88.1,251.2,93.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 266.9,
    className: "st8",
    width: 471.3,
    height: 156.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M152.9,383.8l-17-26.5l-15.5,26.5h-17.8l24.8-39.7L102.2,305h18.2l17,26.4l15.4-26.4h17.8l-24.7,39.6 l25.2,39.2H152.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M198.9,371.2h26v12.5h-41.8V305h15.8V371.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M247.3,381.7c-4.4-1.9-7.9-4.6-10.4-8.1c-2.6-3.5-3.9-7.7-4-12.5h16.9c0.2,3.2,1.4,5.8,3.4,7.7 c2.1,1.9,4.9,2.8,8.5,2.8c3.7,0,6.6-0.9,8.7-2.7c2.1-1.8,3.2-4.1,3.2-6.9c0-2.3-0.7-4.3-2.1-5.8c-1.4-1.5-3.2-2.7-5.4-3.6 c-2.1-0.9-5.1-1.8-8.9-2.9c-5.1-1.5-9.3-3-12.5-4.5c-3.2-1.5-5.9-3.7-8.2-6.7c-2.3-3-3.4-6.9-3.4-11.9c0-4.7,1.2-8.7,3.5-12.2 c2.3-3.5,5.6-6.1,9.8-8c4.2-1.8,9-2.8,14.5-2.8c8.1,0,14.7,2,19.8,5.9c5.1,4,7.9,9.5,8.4,16.5h-17.4c-0.2-2.7-1.3-4.9-3.4-6.7 c-2.1-1.8-5-2.7-8.5-2.7c-3.1,0-5.6,0.8-7.4,2.4c-1.8,1.6-2.8,3.9-2.8,6.9c0,2.1,0.7,3.9,2.1,5.3c1.4,1.4,3.1,2.5,5.2,3.4 c2.1,0.9,5,1.9,8.8,3c5.1,1.5,9.3,3,12.5,4.5c3.2,1.5,6,3.8,8.4,6.8c2.3,3,3.5,7,3.5,11.9c0,4.2-1.1,8.1-3.3,11.7 c-2.2,3.6-5.4,6.5-9.6,8.6c-4.2,2.1-9.2,3.2-15,3.2C256.7,384.6,251.7,383.6,247.3,381.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M350.9,383.8l-17-26.5l-15.5,26.5h-17.8l24.8-39.7L300.2,305h18.2l17,26.4l15.4-26.4h17.8l-24.7,39.6 l25.2,39.2H350.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcXlsx);
export default __webpack_public_path__ + "static/media/ac_xlsx.966f13981008fbc355b1e9455f9162a6.svg";
export { ForwardRef as ReactComponent };